const html = require("choo/html");

const DraggingElement = require("./components/draggingelement.js");
const Menu = require("./components/menu.js");
const GameControls = require("./components/gamecontrols.js");
const ScreenTitle = require("./components/screentitle.js");
const Toolbar = require("./components/toolbar.js");
const Screen = require("./components/screen.js");
const ContextMenu = require("./components/contextmenu.js");
const HINTS = require("./components/hints.js");
import TutorialWrapper from "./components/tutorial-wrapper.js";
function LoadingMessage(text, hintIndex) {
  return html` <div id="app">
    <div class="grid-12">
      <div class="column-12 huge-letters" style="text-align: center;">
        ${text}
      </div>
      <div class="column-12" id="hint"style="text-align: center;">
        hint: ${HINTS[hintIndex]}
      </div>
    </div>
  </div>`;
}
module.exports = function MainView(state, emit) {
  if (state.hintIndex === undefined) {
    state.hintIndex = Math.floor(Math.random() * HINTS.length);
  }
  if (!state.vm) {
    emit("load-vm");
    return LoadingMessage("Loading VM", state.hintIndex);
  }
  if (!state.glitchesLoaded) {
    emit("load-glitches");
    return LoadingMessage("Loading Glitches", state.hintIndex);
  }

  if (!state.soundsLoaded) {
    emit("load-sounds");
    return LoadingMessage("Loading Sounds", state.hintIndex);
  }

  if (!state.partsLoaded) {
    emit("load-parts");
    return LoadingMessage("Loading Parts", state.hintIndex);
  }
  if (!state.project) {
    const stringMatch = "sharedProject";
    if (state.params.project_id.includes(stringMatch)) {
      const sharedProjectId = state.params.project_id.split("=")[1];
      emit("load-shared-project", sharedProjectId);
    } else {
      emit("fetch-project", state.params.project_id);
    }
    return LoadingMessage("Fetching Project", state.hintIndex);
  }

  sanitizeSelections(state);

  if (!state.currentScene) {
    let sceneNum = 0;
    if (state.projectMetadata.startingScene) {
      sceneNum = state.projectMetadata.startingScene;
    }
    emit("load-scene", sceneNum);
    return LoadingMessage("Loading Scene", state.hintIndex);
  }

  if (state.isFullscreen) {
    return html`
      <div id="app">
        <div class="grid-12 main-row">
          <div class="column-9">${Screen(state, emit)}</div>

          <div class="column-3 context-menu">${ContextMenu(state, emit)}</div>
        </div>
      </div>
    `;
  }

  return html`
    <div id="app">
      <div class="grid-12 top-row">
        <div class="column-1 hamburger">${Menu(state, emit)}</div>
        <div class="column-8 game-controls ${state.playingTutorial ? 'tutorial' : ''}">${GameControls(state, emit)}</div>
        <div class="column-3 context-title">${ScreenTitle(state, emit)}</div>
      </div>
      <div class="grid-12 main-row">
        <div class="column-1 menu">${Toolbar(state, emit)}</div>
        <div class="column-8">${Screen(state, emit)}</div>
        <div class="column-3 context-menu">${ContextMenu(state, emit)}</div>
      </div>
      ${TutorialWrapper(state, emit)}
      ${DraggingElement(state, emit)}
    </div>
  `;
};

function sanitizeSelections(state) {
  if (state.selectedTargetId) {
    const target = state.vm.runtime.targets.find(
      (t) => t.id === state.selectedTargetId
    );
    if (!target || target.isDestroyed) {
      state.selectedTargetId = null;
    }
  }
}
